import classNames from "classnames";
import { animated, useSpring } from "@react-spring/web";
import KingIcon from "assets/icons/loyalty/king.svg?react";
import useTranslate from "hooks/useTranslate";
import "./styles.sass";
import LoyaltyNickname from "../../atoms/LoyaltyNickname";
import { ExpSettings } from "../../../types/ExpSettings";

type ProfileWidgetProps = {
  percent: number;
  nameRank: string;
  experience: number;
  experienceRankMax: number | null;
  avatar?: string;
  nickname?: string;
  id?: number;
  handleClickAvatar?: () => void;
  experienceSettings?: ExpSettings;
};

const ProfileWidget = (props: ProfileWidgetProps) => {
  const {
    id,
    nameRank,
    percent,
    experience,
    experienceRankMax,
    avatar,
    nickname,
    experienceSettings,
    handleClickAvatar,
  } = props;
  const t = useTranslate();

  const animatedWidth = useSpring({
    width: `${percent}%`,
    config: { duration: 200 },
  });

  const classNameImg = classNames(
    "ProfileWidget__avatar_img",
    !avatar && "ProfileWidget__avatar_img_empty",
  );

  return (
    <div className="ProfileWidget">
      <div className="ProfileWidget__info">
        <div className="ProfileWidget__avatar">
          <div className={classNameImg} onClick={handleClickAvatar}>
            {avatar ? (
              <img src={avatar} alt="avatar" />
            ) : (
              <KingIcon width="100" height="100" />
            )}
          </div>
        </div>
        <div className="ProfileWidget__name">
          <LoyaltyNickname nickname={nickname} />
          {/* <div className="ProfileWidget__name_title">{nickname}</div> */}
          <div className="ProfileWidget__name_id">ID: {id}</div>
          <div className="ProfileWidget__name_rank">
            {t("loyalty.your.rank")}: <span>{nameRank}</span>
          </div>
        </div>
      </div>
      <div className="ProfileWidget__rank">
        <div className="ProfileWidget__progress">
          <animated.div
            className="ProfileWidget__progress_bar"
            style={{
              ...animatedWidth,
            }}
          />
        </div>
        <div className="ProfileWidget__rank_exp">
          {t("loyalty.level.experience")}: <span>{experience}</span>{" "}
          {experienceRankMax ? `/ ${experienceRankMax}` : null}
          {experienceSettings && (
            <div className="ProfileWidget__rank_exp">
              {experienceSettings.amount.toFixed(0)} XP ={" "}
              {experienceSettings.cost.toFixed(0)} {experienceSettings.currency}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProfileWidget;
